import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { msalConfig } from './authConfig';
import App from './App';
import './index.css';

export const msalInstance = new PublicClientApplication(msalConfig);

// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

// Listen for authentication events with detailed logging
msalInstance.addEventCallback((event) => {
    console.log('[MSAL Event]', event.eventType, event);
    
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
        const account = event.payload.account;
        msalInstance.setActiveAccount(account);
        console.log('[MSAL] Login successful, account set:', account.username);
    }
    
    if (event.eventType === EventType.LOGIN_FAILURE) {
        console.error('[MSAL] Login failed:', event.payload);
        console.error('[MSAL] Error details:', {
            errorCode: event.payload.errorCode,
            errorMessage: event.payload.errorMessage,
            subError: event.payload.subError,
            correlationId: event.payload.correlationId
        });
    }
    
    if (event.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
        console.error('[MSAL] Token acquisition failed:', event.payload);
        console.error('[MSAL] Token error details:', {
            errorCode: event.payload.errorCode,
            errorMessage: event.payload.errorMessage,
            subError: event.payload.subError,
            correlationId: event.payload.correlationId
        });
    }

    if (event.eventType === EventType.LOGOUT_SUCCESS) {
        console.log('[MSAL] Logout successful');
    }

    // Log all authentication interaction complete events
    if (event.eventType === EventType.SSO_SILENT_SUCCESS) {
        console.log('[MSAL] SSO Silent success:', event.payload);
    }
    
    if (event.eventType === EventType.SSO_SILENT_FAILURE) {
        console.error('[MSAL] SSO Silent failure:', event.payload);
    }
});

// Register service worker for PWA capabilities
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js')
            .then((registration) => {
                console.log('SW registered: ', registration);
            })
            .catch((registrationError) => {
                console.log('SW registration failed: ', registrationError);
            });
    });
}

const root = createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <MsalProvider instance={msalInstance}>
            <App />
        </MsalProvider>
    </BrowserRouter>
);